import { useParallaxTransform } from '@/hooks/useParallax';
import SectionTitle from '@/components/base/SectionTitle';

const blocks = [
  {
    title: 'Performance & efficacité',
    points: [
      { text: 'Installation rapide en 15 minutes', icon: 'ri-flashlight-line' },
      { text: 'Maximiser le rendement grâce à un équipement entièrement intégré', icon: 'ri-focus-3-line' },
      { text: 'Assurer un service fluide et rapide même en forte affluence', icon: 'ri-flashlight-line' },
      { text: "Amélioration de l'ergonomie de travail", icon: 'ri-user-smile-line' },
      { text: 'Réduction des coûts de personnel et de montage/démontage', icon: 'ri-price-tag-3-line' },
    ],
  },
  {
    title: 'Flexibilité & image',
    points: [
      { text: 'Solution mobile, autonome et clé en main', icon: 'ri-truck-line' },
      { text: 'Personnalisation complète (branding, covering)', icon: 'ri-palette-line' },
      { text: "Valorisation de votre image et de votre événement", icon: 'ri-vip-crown-line' },
    ],
  },
  {
    title: 'Sécurité',
    points: [
      { text: 'Remorque sécurisée et entièrement fermée à clé', icon: 'ri-lock-2-line' },
    ],
  },
];

export default function WhyUs() {
  const contentRef = useParallaxTransform(0.05);

  return (
    <section id="pourquoi" className="pt-7 pb-8 md:py-24 lg:py-14 overflow-hidden bg-[#fbf9f4] mt-0 md:mt-16 lg:mt-6">
      <div ref={contentRef} className="will-change-transform">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <SectionTitle
            label="Nos Avantages"
            title="Pourquoi Nous Choisir"
            delay={100}
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-10 max-w-6xl mx-auto animate-fade-in-up delay-300">
            {blocks.map((block, i) => (
              <div
                key={block.title}
                className="bg-white rounded-2xl p-6 md:p-8 lg:p-10 animate-fade-in-up flex flex-col transition-all duration-[250ms] ease-out hover:-translate-y-1 hover:shadow-lg hover:scale-[1.01]"
                style={{
                  boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
                  transitionDelay: `${200 + i * 150}ms`,
                }}
              >
                {/* Badge pill title */}
                <div className="mb-6">
                  <span className="inline-block bg-[#00A8B5] text-white px-5 py-2.5 rounded-full text-sm md:text-base font-semibold tracking-wide">
                    {block.title}
                  </span>
                </div>

                {/* Points list */}
                <ul className="flex flex-col gap-3.5 lg:gap-5">
                  {block.points.map((point) => (
                    <li key={point.text} className="flex items-start gap-3">
                      <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`${point.icon} text-[#00A8B5] text-base`}></i>
                      </div>
                      <span className="text-gray-700 text-sm md:text-[15px] leading-relaxed">
                        {point.text}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}